<section class="section-pd bg-light">
    <div class="trinka_container container">
        <div class="row align-items-center">
            <div class="col-md-7 col-lg-7 topBannerWrapper">
                <div class="trinka-title mb-0 top-banner-left ">
                    <h1 class="trinka-sub-title mb-2 p-2">Whitepaper</h1>
                    <h2>Who Owns the Work? AI, Integrity, and Student Responsibility in US Higher Education</h2>
                    <div class="HeadingSubLine1"><span></span><span></span><span></span></div>
                    <p>As AI reshapes higher education, universities face a critical question: Who owns the work?</p>
                    <p>This whitepaper explores how institutions can move beyond AI detection to strengthen student ownership, process transparency, and academic integrity.</p>
                    <div class="btn-group justify-content-left mt-40">
                        <a 
                        class="filled-btn"
                            [class.disabled]="downloadingMap['/assets/resources/Whitepaper-2026.pdf']"
                            [style.pointerEvents]="downloadingMap['/assets/resources/Whitepaper-2026.pdf'] ? 'none' : 'auto'"
                            (click)="openResourcePDF(
                                '/assets/resources/Whitepaper-2026.pdf',
                                'Who Owns the Work? AI, Integrity, and Student Responsibility in US Higher Education'
                            )"
                        >
                        <span *ngIf="downloadingMap['/assets/resources/Whitepaper-2026.pdf']"
                                class="spinner-border spinner-border-sm me-2"></span>
                                
                        {{ downloadingMap['/assets/resources/Whitepaper-2026.pdf'] ? 'Downloading...' : 'Download White Paper' }}
                        </a>
                    </div> 
                </div>
                
            </div>
            <div class="col-md-5 col-lg-4 offset-lg-1">
                <div class="text-center">
                    <img src="assets/images/industry-engagements/whitepaper-2026.webp" class="img-fluid scale-img" style="width:100%" loading="lazy" decoding="async" alt="Evolution logo" />
                </div>
            </div>
        </div>
    </div>
</section>

<div class="modal" id="CaptureLeadForm">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-body">
                <button type="button" class="close" data-dismiss="modal"></button>
                <app-capture-lead 
                [resourceUrl]="selectedLink"
                [resourceTitle]="selectedTitle"
                (formSubmitted)="onFormSubmitted($event)">
                </app-capture-lead>
            </div>
        </div>
    </div>
</div>